import { darken, IconButton } from "@mui/material";
import { styled } from "@mui/material/styles";

export const CustomIconButton = styled(IconButton, {
  shouldForwardProp: (prop) => prop !== "isActive",
})<{ isActive?: boolean }>(({ isActive, theme }) => ({
  ...(!!isActive && {
    backgroundColor: darken(theme.palette.background.paper, 0.1),
  }),
}));
